<template>
  <div>
    <a-modal
      destroyOnClose
      :footer="null"
      :maskClosable="false"
      centered
      :title="title"
      v-model="visible"
      width="80%"
    >
      <a-space>
        <vxe-input
          placeholder="placeholder.orderNo" @clear="refresh"
          @keydown.native.enter="refresh"
          v-model="orderQuery['no']"
        />
        <vxe-input
          placeholder="placeholder.supplierName" @clear="refresh"
          @keydown.native.enter="refresh"
          v-model="orderQuery['customer.name']"
        />
        <vxe-select v-model="orderQuery['owner.id']" :options="owners" placeholder="placeholder.owner" @change="refresh"/>
        <a-date-picker
          v-model="orderQuery.dateFilter.start"
          :disabled-date="disabledStartDate"
          show-today
          valueFormat="YYYY-MM-DD"
          :placeholder="$t('placeholder.startTime')"
        />
        <a-date-picker
          v-model="orderQuery.dateFilter.end"
          :disabled-date="disabledEndDate"
          show-today
          valueFormat="YYYY-MM-DD"
          :placeholder="$t('placeholder.endTime')"
        />
        <a-button type="primary" @click="fetch">{{$t('button.query')}}</a-button>
        <a-button @click="confirm" type="primary" :disabled="selectedOrderRows.length===0">{{ $t('button.confirm') }}</a-button>
        <a-button @click="reset" type="primary">{{ $t('button.reset') }}</a-button>
      </a-space>
      <br /><br />
      <a-table
        :dataSource="orderData"
        :pagination="false"
        :customRow="onClickOrderRow"
        :loading="orderLoading"
        :rowSelection="{selectedRowKeys: selectedOrderRowKeys, onChange: onOrderSelectChange,type:'radio',columnWidth:'50px'}"
        :rowKey="record => record.no"
        size="small"
        bordered>
        <a-table-column :title="$t('business.label.orderNo')" dataIndex="no" align="center"></a-table-column>
        <a-table-column :title="$t('business.label.ownerName')" align="center" dataIndex="owner.name"></a-table-column>
        <a-table-column :title="$t('business.label.operator')" dataIndex="operator" align="center"></a-table-column>
        <a-table-column dataIndex="invoiceTime" :title="$t('business.label.invoiceTime')" align="center">
          <template slot-scope="text">
            {{ moment(text).format('YYYY-MM-DD HH:mm:ss') }}
          </template>
        </a-table-column>
        <a-table-column :title="$t('business.label.orderStatus')" dataIndex="orderStatus" align="center">
          <span slot-scope="text">{{ orderStatusData.find(item => item.ordinal === text).name }}</span>
        </a-table-column>
        <a-table-column :title="$t('business.label.orderType')" dataIndex="orderType.name" align="center"></a-table-column>
      </a-table>
      <vxe-pager :current-page="page" :loading="loading" :page-size="size" :pageSizes="[5, 10, 15, 20]" :total="contentSize" @page-change="pageChange"/>
      <br />
      <a-table
        :dataSource="detailData"
        :loading="detailLoading"
        bordered
        :rowKey="row=>row.key"
        size="middle">
        <a-table-column :title="$t('business.label.index')" dataIndex="index" width="60px" align="center">
          <span slot-scope="text, record, index">{{ index + 1 }}</span>
        </a-table-column>
        <a-table-column dataIndex="sku.item.no" :title="$t('business.label.itemNo')" align="center"></a-table-column>
        <a-table-column dataIndex="sku.item.name" :title="$t('business.label.itemName')" :ellipsis="true" align="center">
          <a-tooltip :title="text" slot-scope="text, record">{{ text }}</a-tooltip>
        </a-table-column>
        <a-table-column dataIndex="sku.pack.specification" :title="$t('business.label.specification')" :ellipsis="true" align="center">
          <a-tooltip :title="text" slot-scope="text, record">{{ text }}</a-tooltip>
        </a-table-column>
        <a-table-column dataIndex="sku.pack.uom" :title="$t('business.label.uom')" :ellipsis="true" align="center">
          <a-tooltip :title="text" slot-scope="text, record">{{ text }}</a-tooltip>
        </a-table-column>
        <a-table-column dataIndex="sku.pack.factor" :title="$t('business.label.factor')" :ellipsis="true" align="center">
          <a-tooltip :title="text" slot-scope="text, record">{{ text }}</a-tooltip>
        </a-table-column>
        <a-table-column dataIndex="sku.lot.productionDate" :title="$t('business.label.productionDate')" :ellipsis="true" align="center">
          <a-tooltip :title="text" slot-scope="text, record">{{ text }}</a-tooltip>
        </a-table-column>
        <a-table-column dataIndex="sku.lot.validUntil" :title="$t('business.label.validUntil')" :ellipsis="true" align="center">
          <a-tooltip :title="text" slot-scope="text, record">{{ text }}</a-tooltip>
        </a-table-column>
        <a-table-column dataIndex="sku.lot.manufacturer" :title="$t('business.label.manufacturer')" :ellipsis="true" align="center">
          <a-tooltip :title="text" slot-scope="text, record">{{ text }}</a-tooltip>
        </a-table-column>
        <a-table-column dataIndex="sku.lot.producingArea" :title="$t('business.label.producingArea')" :ellipsis="true" align="center">
          <a-tooltip :title="text" slot-scope="text, record">{{ text }}</a-tooltip>
        </a-table-column>
        <a-table-column dataIndex="location.no" :title="$t('business.label.locationNo')" align="center"></a-table-column>
        <a-table-column dataIndex="sku.logicalStore.name" :title="$t('business.label.logicalStore')" align="center"></a-table-column>
        <a-table-column dataIndex="quantity" :title="$t('business.label.unqualifiedQuantity')" width="150px" align="center"></a-table-column>
        <a-table-column dataIndex="reasons" :title="$t('business.label.unqualifiedReason')" width="150px"  align="center" :ellipsis="true">
          <a-tooltip :title="text" slot-scope="text, record">{{ text }}</a-tooltip>
        </a-table-column>
      </a-table>
    </a-modal>
  </div>
</template>

<script>
import moment from 'moment'
import { findAll, findEnum, findOne } from '@/api/Api'
import PageUtil from '@/components/Pagination/PageUtil.vue'

export default {
  name: 'DisqualificationPickupModal',
  components: {PageUtil },
  data() {
    return {
      visible: false,
      orderLoading: false,
      detailLoading: false,
      orderData: [],
      detailData: [],
      orderStatusData: [],
      owners: [],
      page: 1,
      size: 5,
      contentSize: 0,
      orderQuery: {
        'no': '',
        'owner.id': undefined,
        dateFilter: {
          start: moment().format('YYYY-MM-DD'),
          end: moment().format('YYYY-MM-DD')
        }
      },
      detailQuery: {
        'no': ''
      },
      selectedOrderRowKeys: [],
      selectedOrderRows: [],
      pickUpData:null
    }
  },
  props: {
    selectType: {
      type: String,
      default: 'radio'
    },
    title: {
      type: String,
      default: '不合格单提取'
    }
  },
  mounted() {
    findAll('partyFactory', { available: true, 'type.ordinal': 1 }).then(res => {
      if (res.success) {
        this.owners = res.result
      }
    })
    findEnum('OrderStatus').then(res => {
      if (res.success) {
        this.orderStatusData = res.result
      }
    })
  },
  methods: {
    pageChange(e) {
      this.page = e.page
      this.size = e.size
      this.fetch()
    },
    init(args) {
      this.orderQuery = {
        'no': '',
        'owner.id': undefined,
        dateFilter: {
          start: moment().format('YYYY-MM-DD'),
          end: moment().format('YYYY-MM-DD')
        }
      }
      this.detailQuery = {
        'no': ''
      }
      this.orderData = []
      this.detailData = []
      this.selectedOrderRows = []
      this.selectedOrderRowKeys = []
      this.pickUpData=null
      this.page = 1
      if (args !== null && args !== undefined) {
        this.args = args
        Object.assign(this.orderQuery, args)
      } else {
        this.args = null
      }
    },
    open(args) {
      this.init(args)
      this.visible = true
      this.fetch()
    },
    fetch() {
      this.orderLoading = true
      this.selectedOrderRows = []
      this.selectedOrderRowKeys = []
      findAll('disqualificationOrderFactory', this.orderQuery, this.page, this.size).then(res => {
          if (res.success) {
            setTimeout(() => {
              this.contentSize = res.contentSize
              this.orderData = res.result
              this.detailData = []
              this.pickUpData=null
              this.orderLoading = false
            }, 200)
          }
        })
    },
    refresh() {
      this.page = 1
      this.fetch()
    },
    getDetailData() {
      this.detailLoading = true
      this.detailQuery.no = this.selectedOrderRowKeys[0]
      findOne('disqualificationOrderFactory', this.detailQuery).then(res => {
        if (res.success) {
          let i = 1
          res.result.details.forEach(item => {
            item.key = i++
          })
          this.detailData = res.result.details
          this.pickUpData=res.result
        }
      }).finally(() => {
        this.detailLoading = false
      })
    },
    onClickOrderRow(record) {
      return {
        on: {
          click: () => {
            this.onOrderSelectChange([record.no], [record])
          }
        }
      }
    },
    onOrderSelectChange(selectedRowKeys, selectedRows) {
      this.selectedOrderRowKeys = selectedRowKeys
      this.selectedOrderRows = selectedRows
      this.getDetailData()
    },
    clearParam() {
      this.init(this.args)
    },
    confirm() {
      this.$emit('change', this.pickUpData)
      this.visible = false
    },
    cancel() {
      this.visible = false
    },
    reset() {
      this.init(this.args)
      this.fetch()
    }
  }
}
</script>
<style scoped>
.query {
  width: 200px;
}
</style>
